var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.976562,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4766 12C13.4766 11.4477 13.9243 11 14.4766 11H18.4766C19.0288 11 19.4766 11.4477 19.4766 12V28C19.4766 28.5523 19.0288 29 18.4766 29H14.4766C13.9243 29 13.4766 28.5523 13.4766 28V12ZM15.4766 13V27H17.4766V13H15.4766Z",
    fill: "#EB8146"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4766 12C21.4766 11.4477 21.9243 11 22.4766 11H26.4766C27.0288 11 27.4766 11.4477 27.4766 12V28C27.4766 28.5523 27.0288 29 26.4766 29H22.4766C21.9243 29 21.4766 28.5523 21.4766 28V12ZM23.4766 13V27H25.4766V13H23.4766Z",
    fill: "#EB8146"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordPauseIcon);
export default __webpack_public_path__ + "static/media/record-pause-icon.e61cf185d778b7cd5becf18791979b0f.svg";
export { ForwardRef as ReactComponent };